import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4336fb73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-table-root" }
const _hoisted_2 = { class: "switch-table-list-wrap" }
const _hoisted_3 = { class: "switch-table-list" }
const _hoisted_4 = { class: "tab-menu-container" }
const _hoisted_5 = { class: "tab-menu-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_switch_table_item = _resolveComponent("switch-table-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDesk, (desk) => {
          return (_openBlock(), _createBlock(_component_switch_table_item, {
            class: "switch-table-list-item",
            key: desk.id,
            activeDesk: -1,
            mData: desk,
            onClick: _withModifiers(($event: any) => (_ctx.$emit('enter-table', desk.id, desk)), ["prevent"])
          }, null, 8, ["mData", "onClick"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "tab-item tab-item-close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
        }, " × "),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 1 }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.switchTab(1)), ["prevent"]))
        }, _toDisplayString(_ctx.t('loby.all')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 2 }]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.switchTab(2)), ["prevent"]))
        }, _toDisplayString(_ctx.t('common.baccarat')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 3 }]),
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.switchTab(3)), ["prevent"]))
        }, _toDisplayString(_ctx.t('common.dragontiger')), 3)
      ])
    ])
  ]))
}